import { put, call } from 'redux-saga/effects';
import { getFeatureFlagSuccess } from '../../../reducers/featureFlagSlice';
import withLoading from '../../../sagas/loadingSaga';
import { api } from '../../../api/featureFlags/featureFlagsApi';

export default function* featureFlagSaga() {
  yield* withLoading(function* () {
    const featureFlagsResponse = yield call(api.getFeatureFlags);
    yield put(getFeatureFlagSuccess(featureFlagsResponse.data));
  });
}
